<div class="two-columns-2-1" *ngIf="settingsForm">
    <div>
        <h1 style="font-weight: 600;">{{ dialogTitle }}</h1>
        <form [formGroup]="settingsForm">
            <mat-form-field>
                <input matInput placeholder="E-Mail" formControlName="userName" />
            </mat-form-field>
            <div class="columns-50-50" [class.grid-row]="editMode">
                <mat-form-field>
                    <mat-label>Anrede</mat-label>
                    <mat-select formControlName="gender">
                        @for (gender of genders; track $index) {
                        <mat-option [value]="gender.value">{{ gender.label }}</mat-option>
                        }
                    </mat-select>
                    <!-- <input *ngIf="!editMode" matInput placeholder="Anrede" [value]="userDetails.gender" disabled> -->
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Titel</mat-label>
                    <mat-select formControlName="title">
                        @for (title of titles; track $index) {
                        <mat-option [value]="title.value">{{ title.label }}</mat-option>
                        }
                    </mat-select>
                    <!-- <input *ngIf="!editMode" matInput placeholder="Titel" [value]="userDetails.title" disabled> -->
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Vorname</mat-label>
                    <input matInput formControlName="firstName" required />
                    <mat-error *ngIf="firstName.hasError('required')">
                        Diese Angabe ist erforderlich
                    </mat-error>
                    <mat-error *ngIf="!firstName.hasError('required') && firstName.hasError('firstnamelength')">
                        Der Vorname darf maximal 60 Zeichen lang sein
                    </mat-error>
                    <mat-error
                        *ngIf="!firstName.hasError('required') && firstName.hasError('firstNameInvalidCharacter')">
                        Bitte keine Zahlen oder Sonderzeichen
                    </mat-error>
                    <mat-icon matSuffix tabindex="-1" class="info-icon"
                        matTooltip="Falls Sie ein Produkt auf Construct-X erwerben, wird dieser Name als Rechnungsempfänger angezeigt."
                        matTooltipPosition="above">
                        info_outline
                    </mat-icon>
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Nachname</mat-label>
                    <input matInput formControlName="lastName" required />
                    <mat-error *ngIf="lastName.hasError('required')">
                        Diese Angabe ist erforderlich
                    </mat-error>
                    <mat-error *ngIf="!lastName.hasError('required') && lastName.hasError('jobDescription')">
                        Der Nachname darf maximal 60 Zeichen lang sein
                    </mat-error>
                    <mat-error *ngIf="!lastName.hasError('required') && lastName.hasError('lastNameInvalidCharacter')">
                        Bitte keine Zahlen oder Sonderzeichen
                    </mat-error>
                    <mat-icon matSuffix tabindex="-1" class="info-icon"
                        matTooltip="Falls Sie ein Produkt auf Construct-X erwerben, wird dieser Name als Rechnungsempfänger angezeigt."
                        matTooltipPosition="above">
                        info_outline
                    </mat-icon>
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Telefonnummer</mat-label>
                    <input matInput formControlName="phoneNumber" (blur)="checkAndSetPhonenumber(false)" />
                    <mat-error *ngIf="phoneNumber.invalid && phoneNumber.value">
                        Bitte eine gültige Telefonnummer angeben
                    </mat-error>
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Mobiltelefonnummer</mat-label>
                    <input matInput formControlName="mobileNumber" (blur)="checkAndSetPhonenumber(true)" />
                    <mat-error *ngIf="mobileNumber.invalid && mobileNumber.value">
                        Bitte eine gültige Mobiltelefonnummer angeben
                    </mat-error>
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Organisation</mat-label>
                    <input matInput placeholder="Organisation" formControlName="employer" maxlength="61" required />
                    <mat-error *ngIf="employer.hasError('required')">
                        Diese Angabe ist erforderlich
                    </mat-error>
                    <mat-error *ngIf="!employer.hasError('required') && employer.hasError('organizationLength')">
                        Die Organisation darf maximal 60 Zeichen lang sein
                    </mat-error>
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Website</mat-label>
                    <input matInput formControlName="website" type="url" />
                    @if (website.hasError('websiteLength')) {
                    <mat-error>
                        Die Website darf maximal 60 Zeichen lang sein
                    </mat-error>
                    }
                    @if (website.hasError('invalidUrl') && !website.hasError('websiteLength')) {
                    <mat-error>
                        Bitte eine valide Website angeben
                    </mat-error>
                    }
                </mat-form-field>
            </div>
            <mat-form-field class="mg-grid">
                <mat-label>Tätigkeit</mat-label>
                <input matInput formControlName="jobDescription" />
                <mat-error *ngIf="jobDescription.hasError('positionLength')">
                    Die Position darf maximal 60 Zeichen lang sein
                </mat-error>
                <mat-error *ngIf="jobDescription.hasError('positionInvalidCharacter')">
                    Bitte keine Zahlen oder Sonderzeichen
                </mat-error>
            </mat-form-field>

            <!-- <mat-form-field *ngIf="editMode">
            <mat-label>Persönliche Beschreibung</mat-label>
            <textarea matInput placeholder="Persönliche Beschreibung" rows="5"
                [(ngModel)]="userDetails.aboutMe"></textarea>
        </mat-form-field>

        <mat-form-field *ngIf="!editMode">
            <mat-label>Persönliche Beschreibung</mat-label>
            <textarea matInput placeholder="Persönliche Beschreibung" rows="5" [value]="userDetails.aboutMe"
                disabled></textarea>
        </mat-form-field> -->

            <mat-slide-toggle formControlName="hasTrackingConsent" class="mg">Cookies für die
                Statistik</mat-slide-toggle>

            <div class="leftColumn">
                <div class="prevent-grid-blowout">
                    <button *ngIf="editMode" matButton="elevated" color="warn" (click)="onEditPress()">
                        Abbrechen
                    </button>
                </div>
                <div class="prevent-grid-blowout">
                    <button *ngIf="editMode" matButton="elevated" color="primary" (click)="onConfirmPress()"
                        [disabled]="settingsForm.invalid">
                        Speichern
                    </button>
                </div>
            </div>

            <!-- <div class="titlep">
            <h3>Projekte</h3>
        </div>
        <div class="column" *ngIf="userProjects.length == 0" else #userHasProjects>
            <p>-</p>
        </div>
        <div #userHasProjects class="column" *ngFor="let project of userProjects">
            <p *ngIf="editMode">{{ project.projectName }}</p>
            <p *ngIf="!editMode" style="color: rgba(var(--app-on-surface-rgb), 0.38)">
                {{ project.projectName }}
            </p>

            <div *ngIf="editMode">
                <app-hexagon-button-text-icon style="float: right" [text]="'Entfernen'"
                    [icon]="'/assets/img/icons/discard.png'" [width]="1.5" (click)="onRemoveProject(project.id)">
                </app-hexagon-button-text-icon>
            </div>
        </div>
        <button mat-raised-button class="btn_green" *ngIf="editMode" (click)="editModeProjects = !editModeProjects">
            Neues Projekt Hinzufügen
        </button>
        <div class="newProject" *ngIf="editModeProjects">
            <mat-form-field appearance="legacy">
                <mat-label>Projektname</mat-label>
                <input matInput maxlength="25" [(ngModel)]="newProjectName" />
                <span matSuffix style="position: relative; bottom: 8px">
                    <button mat-raised-button class="btn_green" (click)="onAddProject(newProjectName)">
                        Hinzufügen
                    </button>
                </span>
            </mat-form-field>
        </div> -->
        </form>
    </div>

    <div>
        <app-logo [required]="false" [fileId]="settingsForm.get('fileId').value" [editDisabled]="!editMode"
            (logoChanged)="onFileIdChange($event)"></app-logo>
    </div>
    <div class="leftColumn">
        <div class="prevent-grid-blowout">
            <button *ngIf="!editMode" matButton="elevated" color="primary" (click)="onEditPress()">
                Bearbeiten
            </button>
        </div>
    </div>
</div>